<template>
    <div class="site-main">
        <keep-alive>
            <HeaderMain :currentRouteName="currentRouteName" :autoOpenAddTrim="autoOpenAddTrim"></HeaderMain>
        </keep-alive>

        <keep-alive>
            <main class="container">
                <component :is="currentComponent" :routeName="currentRouteName"></component>
            </main>
        </keep-alive>

        <FooterMain></FooterMain>

        <ServerWillBeOffNotification></ServerWillBeOffNotification>
    </div>
</template>

<script>
    import TrimsTab from "./trims/TrimsTab";
    import UsersTab from "./admin/users/UsersTab";
    import UserPage from "./admin/users/userPage/UserPage";
    import SettingsPage from "./admin/settings/SettingsPage";
    import HeaderMain from "./header/HeaderMain";
    import ServerWillBeOffNotification from "../system/server-restart/ServerWillBeOffNotification";
    import FooterMain from "./footer/FooterMain";

    export default {
        name: "HomeMain",

        components: {
            FooterMain,
            ServerWillBeOffNotification,
            HeaderMain,
        },

        props: {
            autoOpenAddTrim: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            currentRouteName() {
                return this.$route.name;
            },

            currentComponent() {
                let component = null;

                switch (this.currentRouteName) {
                    case 'home':
                    case 'trims':
                    case 'my-trims':
                        component = TrimsTab;
                        break;

                    case 'users':
                        component = UsersTab;
                        break;

                    case 'user':
                    case 'userProfile':
                    case 'userCreatedTrims':
                    case 'userStatistic':
                        component = UserPage;
                        break;

                    case 'settings':
                    case 'settingsServer':
                    case 'settingsExport':
                        component = SettingsPage;
                        break;
                }

                return component;
            },

        },

    }
</script>

<style scoped>
    .site-main {
        display: flex;
        flex-direction: column;
        min-height: 100%;
    }

    main {
        margin-bottom: 60px;
    }
</style>